import { render, staticRenderFns } from "./ModalJobClose.vue?vue&type=template&id=87c19408&"
import script from "./ModalJobClose.vue?vue&type=script&lang=js&"
export * from "./ModalJobClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports